export default __webpack_public_path__ + "static/media/buildings.c6c33cca.mp4";